import { toStatusType } from 'App/rtk';
import { useToastStatus } from 'commons/hooks';
import { useUnlinkPartnerMutation } from 'domains/Configurations/Users/usersApi';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';

interface UseUnlinkPartnerResult {
  executeUnlink: (partnerId: number, permissionId: number) => Promise<void>;
  isLoading: boolean;
}

const useUnlinkPartner = (onClose: () => void): UseUnlinkPartnerResult => {
  const [unlinkPartner, { isLoading, status }] = useUnlinkPartnerMutation();
  const t = useTranslationConfigurations('partnersListComponent');

  useToastStatus({
    status: toStatusType(status),
    success: t('unlinkPartnerModal.toast.success'),
    error: t('unlinkPartnerModal.toast.error'),
    onSuccess: onClose,
    onError: onClose,
  });

  const executeUnlink = async (partnerId: number, permissionId: number) => {
    await unlinkPartner({ partnerId, permissionId }).unwrap();
  };

  return {
    executeUnlink,
    isLoading,
  };
};

export default useUnlinkPartner;
